import { apiWrapper } from '../helper/api-wrapper';

export const getBankList = async () => {
  try {
    const response = await apiWrapper.get('general/banks');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorBank = async () => {
  try {
    const response = await apiWrapper.get('merchants/bank/list');

    return response;
  } catch (error) {
    throw error;
  }
};

export const addVendorBank = async (data) => {
  try {
    const response = await apiWrapper.post('merchants/bank/add', data);

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateVendorBank = async (data) => {
  try {
    const response = await apiWrapper.post('merchants/bank/update', data);

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteVendorBank = async (data) => {
  try {
    const response = await apiWrapper.post('merchants/bank/delete', data);

    return response;
  } catch (error) {
    throw error;
  }
};

export const activateVendorBank = async (data) => {
  try {
    const response = await apiWrapper.post('merchants/bank/activation', data);

    return response;
  } catch (error) {
    throw error;
  }
};
